/** SPA paths that should be served from the artist portal host, not the consumer app. */
export function isArtistSurfacePath(pathname: string): boolean {
  return (
    pathname.startsWith("/artist") ||
    pathname.startsWith("/upload")
  );
}
